export default "__VITE_ASSET__CH28$3mD__"